import { getGuestId, getBuyerId, cookieJarConstants } from 'dibs-cookie-jar';
import { setGuestId } from '../authModal/authentication/userStorageActions';

function retrieveGuestId() {
    return getGuestId(document.cookie) || '';
}

function hasOldGuestIdFormat() {
    return (retrieveGuestId().match(/-/g) || []).length === 4;
}

export function handleGuestId() {
    /**
     * Attempt to remove cookie set by blog pages. Can't use `js-cookie` to remove it, since it is
     * configured to use a custom`.1stdibs.com` domain.
     *
     * Blog pages set the cookie on the default, which ends up being www.1stdibs.com. That is why
     * we must not pass in the domain when removing the cookie.
     */
    if (hasOldGuestIdFormat()) {
        // Delete cookie
        document.cookie = `${cookieJarConstants.GUEST_ID}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }

    if ((!getBuyerId(document.cookie) && !retrieveGuestId()) || hasOldGuestIdFormat()) {
        setGuestId();
    }
}
